import { Drawer, useOpenable } from '@execonline-inc/execonline-ui';
import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import UseCaseNavigation from '../../../components/Platform/NavigationBar/SidebarNavigation/UseCaseNavigation';
import MainNavigation from './MainNavigation';

export interface Props {
  isOpen: boolean;
  onClose: () => void;
}

function SidebarNavigation({ isOpen, onClose }: Props) {
  const { isOpen: isSubMenuOpen, onClose: onSubMenuClose, onOpen: onSubMenuOpen } = useOpenable();

  const handleClose = () => {
    onClose();
    onSubMenuClose();
  };

  return (
    <Drawer open={isOpen} onClose={handleClose} placement="left">
      {when(isSubMenuOpen, true)
        .map(() => <UseCaseNavigation onClose={handleClose} onSubMenuClose={onSubMenuClose} />)
        .getOrElse(() => (
          <MainNavigation onClose={handleClose} onSubMenuOpen={onSubMenuOpen} />
        ))}
    </Drawer>
  );
}

export default observer(SidebarNavigation);
